import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CreditCard } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useApi, errMsg, ago } from "@/lib/api";

export const PaywallPanel = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  const [price, setPrice] = useState("");
  const load = useCallback(() => api("get", "/admin/paywall").then((x) => { setD(x); setPrice(x.price); }).catch(() => {}), [api]);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const save = async (enabled) => {
    try { await api("put", "/admin/paywall", { enabled, price }); toast.success(enabled ? "Weekend pass is ON" : "Tips are free for everyone"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="rounded-2xl bg-[#131C31] border border-white/5 p-5 space-y-3" data-testid="admin-paywall-panel">
      <h2 className="font-display text-lg font-bold flex items-center gap-2"><CreditCard className="w-4 h-4 text-blue-400" />Weekend pass (PayPal)</h2>
      <p className="text-xs text-slate-500">When on, Saturday & Sunday tips need a one-off pass. Weekday tips stay free. PayPal: <span data-testid="paywall-paypal-status" className={d.paypal_ready ? "text-emerald-300" : "text-amber-300"}>{d.paypal_ready ? `connected (${d.mode === "live" ? "LIVE" : "test mode"})` : "keys not added yet"}</span></p>
      <div className="flex items-center gap-3">
        <span className="text-sm">$</span>
        <input data-testid="paywall-price-input" value={price} onChange={(e) => setPrice(e.target.value)} className="w-20 bg-[#0B101D] border border-white/10 rounded px-2 py-1 text-sm font-mono" />
        <span className="text-xs text-slate-500 mr-auto">AUD per weekend</span>
        <span className="text-xs">{d.enabled ? "On" : "Free"}</span>
        <Switch data-testid="paywall-toggle" checked={d.enabled} onCheckedChange={save} />
      </div>
      {d.payments.length > 0 && (
        <div>
          <p className="text-[11px] uppercase tracking-widest text-slate-500 mb-1">Recent payments</p>
          {d.payments.map((p) => (
            <p key={p.order_id} className="text-xs text-slate-400 py-1 border-t border-white/5">{p.email || "member"} · ${p.amount} · weekend {p.weekend} · <span className={p.status === "COMPLETED" ? "text-emerald-300" : "text-slate-500"}>{p.status}</span> · {p.mode} · {ago(p.created_at)}</p>
          ))}
        </div>
      )}
    </section>
  );
};
